import { makeStyles } from "@saleor/macaw-ui";

interface propsType {
  expandMenu?: boolean;
  bodyPaddingRight?: number;
}

export const bottomFixed = 80;
const useStyles = makeStyles<propsType>(
  theme => ({
    root: {
      overflowX: "auto",
      width: "100%",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      },
      marginBottom: `${bottomFixed}px`
    },
    boxCustomer: {
      borderRadius: 6,
      background: "#FFF",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      overflow: "hidden",
      margin: "1.6rem 0"
    },
    boxHeader: {
      padding: "0.5rem 1.6rem",
      background: theme.palette.gardient.medium,
      color: "#FFF"
    },
    headerTitle: {
      fontWeight: 700,
      fontSize: 14
    },
    headerId: {
      fontSize: 20
    },
    boxBody: {
      padding: 10
    },
    infoRow: {
      display: "flex",
      alignItems: "center",
      background: theme.palette.background.default,
      borderRadius: 6,
      padding: 5,
      margin: "5px 0",
      fontSize: 14
    },
    infoLeft: {
      marginRight: 5,
      color: theme.palette.grey[900]
    },
    infoRight: {
      marginLeft: "auto",
      textAlign: "right",
      color: theme.palette.grey[900]
    },
    tableProduct: {
      marginTop: 30
    },
    mainTable: {
      borderCollapse: "collapse",
      "& .MuiTableRow-root": {
        background: "#FFF",
        "&:hover": {
          background: "#FFF !important"
        },
        "&:nth-child(even)": {
          background: "#FFF"
        }
      },
      "& .MuiFormControl-root": {
        height: 34
      }
    },
    tableTitle: {
      marginBottom: 20,
      display: "flex",
      alignItems: "center",
      height: 50
    },
    btnDelete: {
      marginLeft: "auto"
    },

    cellBackground: {
      "&&&": {
        background: theme.palette.grey[200],
        color: theme.palette.grey[900]
      },
      "& .MuiSvgIcon-root": {
        color: theme.palette.success.light
      }
    },
    tableRow: {
      borderTop: "2px solid white"
    },
    table: {
      borderCollapse: "collapse"
    },
    customerName: {
      color: theme.palette.grey[900]
    },
    colNumber: {
      color: theme.palette.grey[900]
    },
    colProductName: {
      color: theme.palette.grey[900],
      fontWeight: "bold"
    },
    name: {
      color: theme.palette.grey[900],
      fontWeight: "bold"
    },
    subtitle: {
      fontWeight: 400
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5
    },
    emptyCart: {
      display: "flex",
      padding: "1.6rem 2rem",
      alignItems: "center",
      justifyContent: "center",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: "6px",
      overflow: "hidden",
      "& .MuiTypography-root": {
        marginLeft: "1rem"
      }
    }
  }),
  { name: "ShoppingCartDetail" }
);
export default useStyles;
